
import React from "react";
import { SubscriptionContainer } from "./subscription/SubscriptionContainer";

interface SubscriptionManagerProps {
  showHeading?: boolean;
}

export default function SubscriptionManager({ showHeading = true }: SubscriptionManagerProps) {
  return <SubscriptionContainer showHeading={showHeading} />;
}
